import {AbstractPmsApiService} from "./abstract.service";
import {PaytabsTransaction} from "../models";

/**
 * @class PaytabsService
 * @abstract
 * @extends {AbstractPmsApiService<PaytabsTransaction>}
 */
export class PaytabsService extends AbstractPmsApiService {

    /**
     * @type {string}
     * @protected
     */
    get urlPattern() {

        return '/paytabs(/:propertyId)';
    }

    /**
     * @param {Object.<string, *>} attributes
     * @param {...*} params
     * @returns {PaytabsTransaction}
     * @protected
     */
    newModel(attributes, ...params) {

        return new PaytabsTransaction(attributes);
    }

    /**
     * Get credit card information
     *
     * @param {int} propertyId
     *
     * @returns {Promise.<Object>}
     */
    getCreditCardInformation(propertyId) {

        const url = this.url({propertyId: propertyId});

        return this.http
            .get(url + '/credit-card', {
                headers: this.authHeaders,
            })
            .then(this.getDataExtractor())
            .catch(this.getErrorHandler());
    }

    /**
     * @param {Object} params
     * @returns {Promise.<Object>}
     */
    transactionRequest(params = {}) {

        const url = this.url();

        return this.http
            .post(url + '/request', params, {
                headers: this.authHeaders
            })
            .then(this.getDataExtractor())
            .catch(this.getErrorHandler());
    }
}


// WEBPACK FOOTER //
// ./src/pms-api/services/paytabs.service.js